const k = "uk", o = ["uk"];
export {
  k as defaultLanguage,
  o as supportedLngs
};
//# sourceMappingURL=constants.js.map
